module.exports = __webpack_public_path__ + "static/media/gallery4.7579f3bc.jpg";